import { useCallback } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { CardTypes, IPaymentMethod } from 'features/payment/types';

import { cardIconRenderer } from 'components/payment-method-option/credit-card-icon';

export interface IRenderIconType {
  method: IPaymentMethod;
  isMediumSize?: boolean;
  isLargeSize?: boolean;
  isNoBorder?: boolean;
  showGenericIcon?: boolean;
}

export const useRenderIconType = ({
  method,
  isMediumSize = false,
  isLargeSize = false,
  isNoBorder = false,
  showGenericIcon = false,
}: IRenderIconType) => {
  return useCallback(() => {
    return (
      (method.credit &&
        cardIconRenderer({
          methodType: method.credit.cardType,
          isMediumSize,
          isLargeSize,
          isNoBorder,
          showGenericIcon,
        })) ||
      (method.prepaid && (
        <Icon
          accessibilityHidden
          variant={isNoBorder ? 'giftCardNoBorder' : 'giftCard'}
          size={isMediumSize ? 'md' : isLargeSize ? 'xl' : null}
        />
      )) ||
      (method.venmo &&
        cardIconRenderer({
          methodType: CardTypes.VENMO,
          isMediumSize,
          isLargeSize,
          isNoBorder,
        })) ||
      (method.paypal &&
        cardIconRenderer({
          methodType: CardTypes.PAYPAL,
          isMediumSize,
          isLargeSize,
          isNoBorder,
        })) ||
      (method.cash &&
        cardIconRenderer({
          methodType: CardTypes.CASH,
          isMediumSize,
          isLargeSize,
          isNoBorder,
        })) ||
      (method.cashapp &&
        cardIconRenderer({
          methodType: CardTypes.CASHAPP,
          isMediumSize,
          isLargeSize,
          isNoBorder,
        }))
    );
  }, [method, isMediumSize, isLargeSize, isNoBorder, showGenericIcon]);
};
